module.exports = __webpack_public_path__ + "img/upp.c0901159.png";